function updateHeadlineSelectedCount(faqCardElement) {
	const countChecked = faqCardElement.querySelectorAll('input[type="checkbox"]:checked').length;
	const faqCardHeading = faqCardElement.querySelector('.faq-card__header h3');

	faqCardHeading.textContent = faqCardHeading.textContent.replace(/\s+\(\d+ selected\)/gi, '');

	if (countChecked > 0) {
		faqCardHeading.textContent = `${faqCardHeading.textContent} (${countChecked} selected)`;
	}
}

function countCharactersSelected() {
	this.currentStepElement.addEventListener('change', (event) => {
		for (const faqCard of this.currentStepElement.querySelectorAll('.faq-card')) {
			updateHeadlineSelectedCount(faqCard);
		}
	});

	// Trigger the 'change' event we just added to update counts for
	// elements that already have checked inputs. This can happen when
	// the costumed character resemblances step gets restored.
	this.currentStepElement.dispatchEvent(new Event('change'));
}

export {
	countCharactersSelected
}